import React, { useState } from "react";

import { Box, Button, Text, Layer } from "grommet"
import { CheckboxSelected } from "grommet-icons"

import {
    ActionPanelZkData
} from '../health2/details/HealthStatusServiceHostActionsPanels'

import { useToasts } from 'react-toast-notifications'
import TriageCommandsEachCommandDetail from '../triage/TriageCommandsEachCommandDetail'
import envConfig from '../../utils/envConfig'


export const VerifyZKData = ({ zookeeperData, token, envSelected, host, zk_app_name, mTimeHasura }) => {

    const [hide, setHide] = useState(true);
    const toggleView = () => {
        setHide(!hide)
    }
    const liteMode = envConfig[process.env.REACT_APP_ENVIRONMENT]['lite']

    return (
        <>{!liteMode &&
            <Box
                justify="center"
                align="center"
                gap="none"
                background="dark-2"
                alignSelf="center"
                width="90px"
                pad="2px"
                alignContent="center"
                round="xsmall"
            >
                <Button onClick={toggleView} plain label={<Text color="white" size="12px" weight="normal">Verify</Text>} margin={{ top: "xxsmall" }} hoverIndicator={{ color: "light-1", opacity: "weak" }} icon={<CheckboxSelected size="16px" color="white" />} />
                <ExpandedData zookeeperData={zookeeperData} token={token}
                    zk_app_name={zk_app_name} host={host} mTimeHasura={mTimeHasura}
                    envSelected={envSelected} hide={hide} setHide={setHide} />
            </Box>
        }
        </>
    )
}

const ExpandedData = ({ zookeeperData, token, envSelected, hide, setHide, host, zk_app_name, mTimeHasura }) => {

    const { addToast } = useToasts()
    const [taskID, setTaskId] = useState("")

    let data = [
        {
            'type': 'triage_result',
            'subheader': 'Result',
            'content': {
                taskid: taskID,
            },
        },
        {
            'type': 'triage_log',
            'subheader': 'Log',
            'content': taskID,
        },
        {
            'type': 'triage_compare',
            'subheader': 'Compare',
            'content': {
                taskid: taskID,
                zookeeperData: zookeeperData,
                mTimeHasura: mTimeHasura
            },
        }
    ]

    return (
        <>
            {!hide &&
                <Layer
                    full
                    position="right"
                    width="80%"
                    margin={{ left: "200px" }}
                    onEsc={() => {
                        setHide(true);
                    }}
                    onClickOutside={() => {
                        setHide(true);
                    }}
                >
                    <Box pad="small" background="light-2" fill>
                        <Text size="small" weight="bold">Verify ZK Data Details </Text>
                        <Box pad="small" width="500px" margin={{ bottom: "small" }} direction="row" gap="small">
                            <ActionPanelZkData
                                appName="zookeeper"
                                commandName="zk_data"
                                label="Get Latest ZK Data"
                                host={host}
                                zk_app_name={zk_app_name}
                                env={envSelected}
                                token={token}
                                addToast={addToast}
                                setTaskId={setTaskId}
                            />
                        </Box>
                        {taskID &&
                            <TriageCommandsEachCommandDetail
                                detailView={{ data: data }} defaultSubTab="Compare"
                            />
                        }
                    </Box>
                </Layer>
            }
        </>
    )
}


export default VerifyZKData
